// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__dFe4U","notes":"Notes_notes__1ySH8"};